import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import Fallback from '@/components/uiKit/Fallback';
import { SiteDataType } from '@/hooks';
import { SitePanel } from './SitePanel';

interface SitesListProps {
  sitesData: SiteDataType[];
}

export const SitesList = ({ sitesData }: SitesListProps) => {
  return (
    <ErrorBoundary FallbackComponent={Fallback}>
      <div className="flex flex-col gap-4 overflow-auto h-full w-full">
        {sitesData.map((site) => (
          <SitePanel key={site.site_id} site={site} />
        ))}
      </div>
    </ErrorBoundary>
  );
};
